export * from './main';
import * as main from './main';
export default main;


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/index.js